import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { semanticColors, foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    height: '100%',
    width: '100%',
    padding: '24px',
    paddingBottom: '64px',
    overflowY: 'auto',
  },
  headerSection: {
    marginBottom: '24px',
  },
  header: {
    marginBottom: '8px',
  },
  columnLayout: {
    display: 'flex',
    width: '100%',
  },
  formColumn: {
    width: '45%',
  },
  previewColumn: {
    width: '55%',
    padding: '16px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    maxWidth: '500px',
  },
  setHomePageCheckbox: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '8px',
    color: semanticColors.foreground.primary,
    paddingLeft: '8px',
    marginLeft: '0px',
  },
  formItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  formItemLabel: {
    color: semanticColors.foreground.primary,
    fontWeight: 500,
  },
  formItemDescription: {
    color: semanticColors.foreground.secondary,
  },
  loadingContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  noPreview: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '600px',
  },
  textField: {
    '& .MuiInputBase-root.MuiOutlinedInput-root': {
      margin: 0
    }
  },
  previewLabel: {
    fontWeight: foundations.typography.fontWeight.medium,
  },
  radioButton: {
    '& input[type="radio"]': {
      display: 'none',
    },
  },
});
